import { isInUIC } from '@Utils/common';
import { createGlobalStore } from 'hox';
import { useCallback, useEffect, useState } from 'react';

const getHeightCSSCalc = (offset?: number) => {
  if (offset) return `calc(100vh - ${offset}px)`;
  return '100vh';
};

function useLayout() {
  const [headerHeight, setHeaderHeight] = useState<number>(isInUIC() ? 0 : 48);
  const [bannerHeight, setBannerHeight] = useState<number>(0);
  const [layoutHeight, setLayoutHeight] = useState<string>(
    getHeightCSSCalc(headerHeight)
  );

  const setLayoutBanner = useCallback(
    (params: { visible: boolean; height?: number }) => {
      if (params.visible) {
        setBannerHeight(params.height || 40);
      } else {
        setBannerHeight(0);
      }
    },
    []
  );

  useEffect(() => {
    setLayoutHeight(
      isInUIC()
        ? getHeightCSSCalc()
        : getHeightCSSCalc(headerHeight + bannerHeight)
    );
  }, [headerHeight, bannerHeight]);

  return {
    layoutHeight,
    setLayoutBanner,
    headerHeight,
    setHeaderHeight,
    bannerHeight,
  };
}
export const [useLayoutStore] = createGlobalStore(useLayout);
